import React from "react";
import "../../styles/Modal.scss";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const RejectionNotesModal = ({
  isOpen,
  onClose,
  noteInput,
  handleInputChange,
  onOk,
}) => {
  if (!isOpen) {
    return null;
  }
  const onClickProceedButton = () => {
    onOk();
    onClose();
  };
  return (
    <div className="modal">
      <div
        className="modal-content"
        style={{ minWidth: "30vw", fontSize: "12px" }}
      >
        <div className="close-button" onClick={onClose}>
          <span>&times;</span>
        </div>
        <p style={{ fontSize: 15 }}>
          <b>What is the cause of rejection ?</b>
        </p>
        <input
          type="text"
          value={noteInput}
          onChange={handleInputChange}
          placeholder="Type your reason here"
        />
        <button
          className="reject-button"
          onClick={onClickProceedButton}
          disabled={noteInput === ""}
          style={{ opacity: noteInput === "" ? 0.7 : 1, marginTop: 10 }}
        >
          Proceed
        </button>
      </div>
    </div>
  );
};

export default RejectionNotesModal;
